// src/components/zones/ThalwegTrench/SwimmingBotoDolphin.jsx
import React, { useRef, useEffect } from 'react';
import '../../../css/swim.css';

export default function SwimmingBotoDolphin({
  width = 80,
  swimDuration = '30s',
  tailDuration = '0.8s',
  minTop = 80,
  maxTop = 100,
  onClick,
  highlight = false,
}) {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const wrapperEl = wrapperRef.current;
    const imgEl = imgRef.current;
    if (!wrapperEl || !imgEl) return;

    const randomStartTop = minTop + Math.random() * (maxTop - minTop);
    wrapperEl.style.top = `${randomStartTop}%`;
    wrapperEl.style.animationDuration = swimDuration;
    wrapperEl.style.width = `${width}px`;    // keep hit area tight to the image
    imgEl.style.animationDuration = tailDuration;
  }, [swimDuration, tailDuration, minTop, maxTop, width]);

  const wrapperClass = [
    'swim-boto-wrapper',
    highlight ? 'inline-block ring-4 ring-yellow-300 rounded-full scale-110' : '',
  ].filter(Boolean).join(' ');

  const botoUrl = '/images/animals/80_100m/predator/amazon_river_dolphin_head.png';

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={wrapperClass}
      style={{
        left: 0,
        position: 'absolute',
        overflow: 'visible',
        // pointerEvents: 'auto' by default
      }}
      onClick={onClick} // wrapper also receives clicks
    >
      <img
        ref={imgRef}
        src={botoUrl}
        alt="Amazon River Dolphin"
        className="swim-boto-img"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        draggable={false}
        style={{
          width: `${width}px`,
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
        }}
      />
    </div>
  );
}
